import React from 'react'
import {useHistory} from 'react-router-dom'
import {motion} from "framer-motion";

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      duration:0.5
    }
  }
}
export default function Template5() {
	const history=useHistory()
	const data=JSON.parse(localStorage.getItem("resumeData"))
	function download(){
		var body=document.body.innerHTML
		var data=document.getElementById("resume").innerHTML
		document.body.innerHTML=data
		document.body.style.background="white"
		window.print()
		document.body.style.background="linear-gradient(to right,rgb(10, 81, 89) 20%,rgb(13, 153, 136),rgb(10, 81, 89) 80%)"
		document.body.innerHTML=body
		window.location.reload()
	}
	if(!data) return <motion.div className="container" exit={{opacity:0}} variants={contVariant} initial="hidden" animate="visible"><h2>Something went wrong, please resave the data</h2></motion.div>
	return (
		<>
		<motion.div className="container" style={{flexDirection:"column"}} exit={{opacity:0}}
			variants={contVariant}
        	initial="hidden"
        	animate="visible"
		>
			<div>
				<button className="save-btn mx-2" onClick={()=>history.push("/choose-resume-template")}>Back</button>
				<button className="save-btn" onClick={download}>Download</button>
			</div>
			<div className="resume" id="resume">
				<div className="mt-4" style={{color:"black",textAlign:"center",padding:"20px",fontWeight:400}}>
					<h1><em>{data.name}</em></h1>
					<p className="py-3 mb-0 text-light" style={{background:"linear-gradient(90deg,rgb(224, 25, 11) 30%,rgb(227, 105, 11))"}}>{data.designation}</p>
				</div>
				<hr className="m-0"/>
				<div className="temp-5-section2 ">
					<div className="mt-5 ml-0" style={{color:"black"}}>
					<div className="head"><i className="fa fa-info mx-3" aria-hidden="true"></i>  Info</div>
					<p><strong><i className="fas fa-address-card ml-2 mt-4 mr-0"></i></strong><span style={{marginLeft:"4%"}}>{data.address}</span></p>
					<p><strong><i className="fas fa-phone ml-2 mr-0"></i></strong><span style={{marginLeft:"5%"}}>{data.contact}</span></p>
					<p><strong><i className="fas fa-envelope-open ml-2 mr-0"></i></strong><span style={{marginLeft:"5%"}}><a href={`mailto:${data.email}`} style={{color:"black"}}>{data.email}</a></span></p>
					</div>
					<ul className="temp-5 mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					<li><div className="head"><i className="fas fa-code mx-2"></i>  Skills</div>
						<div className="my-2">
							<ul className="skills" style={{listStyle:"none"}}>
							{data.skills.map((skill,index)=>(
								<li><strong>{skill.skill}</strong>
									{skill.prof && (<div className="progress" style={{width:"80%"}}>
  									<div className="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{width:"85%"}}></div>
									</div>
									)}
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head mt-2"><i className="fas fa-clipboard-list mx-2"></i>  Additional Information</div>
						<div className="my-3">
							<ul>
							{data.addInfo.map((info,index)=>(
								<li><strong>{info.title}</strong>  : <a href={`${info.reference}`}>{info.reference}</a></li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head mt-2"><i className="fa fa-language mx-2" aria-hidden="true"></i>   Languages Known</div>
						<div  className="my-3">
							<ul className="lang" style={{listStyle:"none"}}>
							{data.langKnown.map((lang,index)=>(
								<><li>{lang}</li><hr className="mx-2"/></>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
				<div className="temp-5-section1" style={{color:"black"}}>
					<ul className="mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					<li><div className="head"><i className="fas fa-graduation-cap mx-2"></i>  Education</div>
						<div className="my-2">
							<ul>
							{data.education.map((edu,index)=>(
								<li>
									<p><strong className="education">{edu.course} {edu.field}</strong><br/>
									   {edu.college}<br/>
									   Aggregate : {edu.score}%<br/>
									   <em>({(new Date(edu.start)).toDateString().substring(4,8)+(new Date(edu.start)).toDateString().substring(11)} - {(new Date(edu.end)).toDateString().substring(4,8)+(new Date(edu.end)).toDateString().substring(11)})</em><hr className="mx-2"/>
									</p>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li ><div className="head"><i className="fa fa-briefcase mx-2" aria-hidden="true"></i>  Work Experience</div>
						<div className="my-3">
							<ul>
							{data.workExp.map((work,index)=>(
								<li><strong>{work.company}</strong><br/>
									<ul>
										<li style={{textAlign:"justify"}}>{work.desc}<br/> <small>{work.title}</small> </li>
									</ul>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-book-reader mx-2"></i>  Interests</div>
						<div  className="my-3">
							<ul>
							{data.interests.map((interest,index)=>(
								<li>{interest}</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-laptop-code mx-2"></i>  Projects</div>
						<div className="my-3">
							<ul>
							{data.projects.map((project,index)=>(
								<li><strong>{project.title}</strong><br/>
									{project.desc} <br/>
									<a href={`${project.reference}`}>{project.reference}</a>
								</li>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
			</div>
		</motion.div>
		</>
	)
}